import { useUserContext } from "../contexts/UserContext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { API_URL } from '../config/api';

export default function Home() {
  const { login, clearUser } = useUserContext();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("login");

  const [loginData, setLoginData] = useState({ email: '', password: '' });
  const [registerData, setRegisterData] = useState({
    nom: '',
    prenom: '',
    surnom: '',
    email: '',
    password: '',
    numero: '',
    adresse: '',
    photo: null,
  });
  const [photoPreview, setPhotoPreview] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: { 'Content-Type': "application/json" },
        body: JSON.stringify(loginData),
      });

      const result = await response.json();

      if (response.ok && result?.admin?._id) {
        login({
          ...result.admin,
          id: result.admin._id,
          token: result.token
        });

        toast.success(`Bienvenue ${result.admin.prenom || ''} !`);
        navigate("/Accueil");
      } else {
        toast.error(result.message || "Échec de la connexion");
      }
    } catch (error) {
      console.error("Erreur lors de la connexion :", error);
      toast.error("Erreur serveur");
    }
  };

  const handleLogout = () => {
    clearUser();
    toast.success("Déconnexion réussie !");
    navigate("/");
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      Object.entries(registerData).forEach(([key, value]) => {
        if (value) formData.append(key, value);
      });

      const response = await fetch(`${API_URL}/admin/register`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        toast.success("Inscription réussie !");
        setActiveTab("login");
        setRegisterData({
          nom: '',
          prenom: '',
          surnom: '',
          email: '',
          password: '',
          numero: '',
          adresse: '',
          photo: null,
        });
        setPhotoPreview(null);
      } else {
        toast.error(data.message || "Erreur d'inscription");
      }
    } catch (error) {
      console.error("Erreur inscription :", error);
      toast.error("Erreur serveur");
    }
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setRegisterData({ ...registerData, photo: file });
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPhotoPreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setPhotoPreview(null);
    }
  };

  return (
    <div style={styles.container}>
      <Toaster position="top-right" />

      <div style={styles.card}>
        <div style={styles.logoContainer}>
          <img src={`${process.env.PUBLIC_URL}/logo df.png`} alt="Logo" style={styles.logo} />
        </div>

        {/* ✅ Message de bienvenue */}
        <h1 style={styles.welcomeTitle}>Bienvenue sur l’espace Admin</h1>
        <p style={styles.welcomeText}>
          Connectez-vous pour gérer vos produits, commandes et plus encore.
        </p>

        {activeTab === "login" && (
          <>
            <h2 style={styles.title}>Connexion Admin</h2>
            <form onSubmit={handleLogin} style={styles.form}>
              <div style={styles.formGroup}>
                <label>Email</label>
                <input
                  type="email"
                  value={loginData.email}
                  onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
                  required
                  style={styles.input}
                  className="input-animated"
                />
              </div>
              <div style={styles.formGroup}>
                <label>Mot de passe</label>
                <input
                  type="password"
                  value={loginData.password}
                  onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                  required
                  style={styles.input}
                  className="input-animated"
                />
              </div>
              <button type="submit" style={styles.submitBtn}>Se connecter</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    // background: "linear-gradient(135deg, #4F46E5, #3B82F6, #06B6D4)",
    backgroundSize: "400% 400%",
    animation: "gradientBG 15s ease infinite",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem",
  },
  card: {
    // background: "rgba(255, 255, 255, 0.85)",
    backdropFilter: "blur(10px)",
    width: "400px",
    padding: "2rem",
    borderRadius: "16px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
    textAlign: "center",
  },
  logoContainer: { marginBottom: "1rem" },
  logo: { width: "100px" },
  welcomeTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#1E3A8A",
    marginBottom: "0.25rem",
  },
  welcomeText: {
    fontSize: "0.95rem",
    color: "#334155",
    marginBottom: "1rem",
  },
  title: { marginBottom: "0.25rem" },
  form: { textAlign: "left" },
  formGroup: { marginBottom: "1rem" },
  input: {
    width: "100%",
    padding: "0.75rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #CBD5E1",
    boxSizing: "border-box",
    outline: "none",
    transition: "0.3s",
  },
  submitBtn: {
    width: "100%",
    padding: "0.75rem",
    background: "linear-gradient(90deg, #4F46E5, #3B82F6)",
    border: "none",
    borderRadius: "8px",
    color: "white",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "0.3s",
  },
};

// Ajoute ça dans ton CSS global :
